class OtherOrganization {
  constructor(title, phoneNumber) {
    this.title = title;
    this.phoneNumber = phoneNumber;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allOtherOrganizations: [],
      allOtherOrganizationsForOther: [],
      otherOrganization: new OtherOrganization('', ''),
      otherOrganizationPaginationList: [],
    };
  },
  methods: {
    getListOfOtherOrganizationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllOtherOrganizations').then(() => {
        if (this.$store.state.otherOrganizationModule.successFlag) {
          // this.allOtherOrganizationsForOther =
          //   this.$store.state.otherOrganizationModule.allOtherOrganizations;

          this.allOtherOrganizationsForOther = Array.isArray(this.$store.state.otherOrganizationModule.allOtherOrganizations)
            ? this.$store.state.otherOrganizationModule.allOtherOrganizations
            : [];

          if (this.$route.name == 'user') {
            this.allUserOtherOrganizations = this.allOtherOrganizationsForOther;
            this.readyUserOtherOrganization();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.otherOrganizationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfOtherOrganizationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.otherOrganizationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfOtherOrganizationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllOtherOrganizations: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllOtherOrganizations').then(() => {
        if (this.$store.state.otherOrganizationModule.successFlag) {
          // this.allOtherOrganizations =
          //   this.$store.state.otherOrganizationModule.allOtherOrganizations;

          this.allOtherOrganizations = Array.isArray(this.$store.state.otherOrganizationModule.allOtherOrganizations)
            ? this.$store.state.otherOrganizationModule.allOtherOrganizations
            : [];

          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.otherOrganizationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllOtherOrganizations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.otherOrganizationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllOtherOrganizations();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfOtherOrganizationsWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getOtherOrganizationsWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          title: this.searchText,
          cityId: this.searchCityId,
        })
        .then(() => {
          if (this.$store.state.otherOrganizationModule.successFlag) {
            this.otherOrganizationPaginationList = [];
            let temp = this.$store.state.otherOrganizationModule.otherOrganizations;
            for (let i = 0; i < temp.length; i++) {
              this.otherOrganizationPaginationList.push({
                counter: i + 1,
                title: temp[i].title ? temp[i].title : '-',
                phoneNumber: temp[i].phoneNumber ? temp[i].phoneNumber : '-',
                id: temp[i].id,
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.otherOrganizationModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.otherOrganizationModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.otherOrganizationModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.otherOrganizationModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfOtherOrganizationsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.otherOrganizationModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfOtherOrganizationsWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addOtherOrganizationFunction: function () {
      if (!this.otherOrganization.title) {
        this.snackText = 'عنوان ارگان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.otherOrganization.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان ارگان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      if (this.otherOrganizationphoneNumbers.length > 0) {
        for (let i = 0; i < this.otherOrganizationphoneNumbers.length; i++) {
          this.otherOrganization.phoneNumber += this.otherOrganizationphoneNumbers[i].text;
          this.otherOrganization.phoneNumber += ',';
        }
      }
      if (
        this.otherOrganization.phoneNumber != null &&
        this.otherOrganization.phoneNumber.length > 0 &&
        this.otherOrganization.phoneNumber.charAt(this.otherOrganization.phoneNumber.length - 1) ==
        ','
      ) {
        this.otherOrganization.phoneNumber = this.otherOrganization.phoneNumber.substring(
          0,
          this.otherOrganization.phoneNumber.length - 1,
        );
      }
      this.$store.dispatch('addOtherOrganization', this.otherOrganization).then(() => {
        if (this.$store.state.otherOrganizationModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' ارگان با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.otherOrganization = new OtherOrganization('', '');
          this.otherOrganizationphoneNumbers = [];
          this.getListOfOtherOrganizationsWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.otherOrganizationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.otherOrganizationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getOtherOrganizationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getOtherOrganization', id).then(() => {
        if (this.$store.state.otherOrganizationModule.successFlag) {
          let temp = this.$store.state.otherOrganizationModule.otherOrganization;
          this.otherOrganization.id = temp.id;
          this.otherOrganization.title = temp.title;
          if (temp.phoneNumber.length > 0) {
            let phoneNumbers = temp.phoneNumber.split(',');
            for (let i = 0; i < phoneNumbers.length; i++) {
              this.otherOrganizationphoneNumbers.push({
                text: phoneNumbers[i],
                id: i + 1,
              });
            }
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.otherOrganizationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getOtherOrganizationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.otherOrganizationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getOtherOrganizationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editOtherOrganizationFunction: function () {
      if (!this.otherOrganization.title) {
        this.snackText = 'عنوان ارگان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.otherOrganization.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان ارگان نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      if (this.otherOrganizationphoneNumbers.length > 0) {
        for (let i = 0; i < this.otherOrganizationphoneNumbers.length; i++) {
          this.otherOrganization.phoneNumber += this.otherOrganizationphoneNumbers[i].text;
          this.otherOrganization.phoneNumber += ',';
        }
      }
      if (
        this.otherOrganization.phoneNumber != null &&
        this.otherOrganization.phoneNumber.length > 0 &&
        this.otherOrganization.phoneNumber.charAt(this.otherOrganization.phoneNumber.length - 1) ==
        ','
      ) {
        this.otherOrganization.phoneNumber = this.otherOrganization.phoneNumber.substring(
          0,
          this.otherOrganization.phoneNumber.length - 1,
        );
      }
      this.$store.dispatch('editOtherOrganization', this.otherOrganization).then(() => {
        if (this.$store.state.otherOrganizationModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfOtherOrganizationsWithPagination();
          this.snackText = ' ارگان با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.otherOrganization = new OtherOrganization('', '');
          this.otherOrganizationphoneNumbers = [];
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.otherOrganizationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.otherOrganizationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteOtherOrganizationFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteOtherOrganization', this.otherOrganizationId).then(() => {
        if (this.$store.state.otherOrganizationModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfOtherOrganizationsWithPagination();
          this.snackText = ' ارگان با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.otherOrganizationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.otherOrganizationModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteOtherOrganizationFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.otherOrganizationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
